// src/DBTMap.js
import React, { useMemo, useRef } from "react";
import { MapContainer, GeoJSON } from "react-leaflet";
import L from "leaflet";
import "./DBTMap.css";

const centerIndia = [22.5, 82];

function valueToColor(p) {
  const clamp = Math.max(0, Math.min(1, Number.isFinite(p) ? p : 0));
  const r = Math.round(236 + (56 - 236) * clamp);
  const g = Math.round(233 + (99 - 233) * clamp);
  const b = Math.round(252 + (171 - 252) * clamp);
  return `rgb(${r},${g},${b})`;
}

export default function DBTMap({ geo, metrics, metric, onHoverPhoneTypes }) {
  const geoRef = useRef(null);

  const styleFn = (feature) => {
    const name = feature.properties?.st_nm;
    const val = metrics?.[name]?.[metric] ?? 0;
    return {
      fillColor: valueToColor(val),
      color: "#1d4ed8",
      weight: 1,
      fillOpacity: 0.85,
    };
  };

  const onEachFeature = (feature, layer) => {
    const state = feature.properties?.st_nm;
    const data = metrics?.[state];
    if (!data) return;
  
    layer.on({
      click: () => {
        if (onHoverPhoneTypes && data.phoneTypes) {
          onHoverPhoneTypes(data.phoneTypes, state);
        }
      },
    });
  
    const pct = (v) =>
      v === null || v === undefined ? "—" : `${(v * 100).toFixed(1)}%`;
  
    let html = `<div class="dbt-tooltip">
      <div><b>${state}</b></div>
      <div>Yes: <b>${pct(data.yes)}</b></div>
      <div>No: <b>${pct(data.no)}</b></div>
      <div>Blank: <b>${pct(data.blank)}</b></div>`;
  
    // Gender breakdown
    if (data.gender && Object.keys(data.gender).length) {
      html += `<div><b>Gender Breakdown:</b></div>`;
      Object.entries(data.gender).forEach(([gender, val]) => {
        html += `<div>${gender}: ${pct(val)}</div>`;
      });
    }
  
    // Age group breakdown
    if (data.ageGroups && Object.keys(data.ageGroups).length) {
      html += `<div><b>Age Group Breakdown:</b></div>`;
      Object.entries(data.ageGroups).forEach(([ageGroup, ageData]) => {
        const val = ageData[metric] ?? 0; // match current metric (yes/no/blank)
        html += `<div>${ageGroup}: ${pct(val)}</div>`;
      });
    }
  // 👇 add the "Click to view Purpose of loan" text here
html += `<div style="margin-top:6px; font-size:12px; color:#007bff; cursor:pointer;">
Click to view Phone Type Distribution

</div>`;
    html += `</div>`;
  
    layer.bindTooltip(html, {
      sticky: true,
      direction: "top",
      opacity: 0.95,
      className: "custom-tooltip",
    });
  };
  

  const bounds = useMemo(() => {
    try {
      const gj = L.geoJSON(geo);
      return gj.getBounds();
    } catch {
      return null;
    }
  }, [geo]);

  return (
    <MapContainer
      className="map-container"
      center={centerIndia}
      zoom={5}
      scrollWheelZoom={false}
      bounds={bounds || undefined}
      attributionControl={false}
    >
      <GeoJSON
        ref={geoRef}
        data={geo}
        style={styleFn}
        onEachFeature={onEachFeature}
      />

      <div className="legend">
        <div>DBT (%)</div>
        <div
          className="legend-bar"
          style={{
            background: "linear-gradient(to right, #dbeafe, #2563eb)",
          }}
        ></div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>0%</span>
          <span>100%</span>
        </div>
      </div>
    </MapContainer>
  );
}
